var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 7,
    height: 7,
    viewBox: "0 -0.02 6.35 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08 0H1.054C.896 0 .767.129.767.288v.191c0 .16.129.288.287.288 0 1.09.612 2.01 1.448 2.3-.836.291-1.448 1.21-1.448 2.3-.158 0-.287.13-.287.288v.192c0 .159.129.288.287.288H5.08c.159 0 .288-.13.288-.288v-.192c0-.159-.129-.287-.288-.287 0-1.09-.611-2.01-1.448-2.3C4.47 2.776 5.08 1.856 5.08.766c.159 0 .288-.129.288-.288V.288C5.368.128 5.239 0 5.08 0zm-.767 5.368H1.821c0-.928.554-1.726 1.246-1.726.693 0 1.246.797 1.246 1.726z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-424 -962) translate(424 962)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gsrxlww0xb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p5aatcyb2a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#p5aatcyb2a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#gsrxlww0xb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H6.135V6.135H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassStart);
export default __webpack_public_path__ + "static/media/hourglass-start.5dcc110f578ec31d0c4c4cca213d97be.svg";
export { ForwardRef as ReactComponent };